import { useId } from 'react';
import { OverlayTrigger, Popover } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import usePDL from '../../pdl/usePDL.ts';

const helpStyle = { cursor: 'help' };

export interface ReadOnlyIconProps {
    dataRowOwnerId: number;
}

const ReadOnlyIconButton = (props: ReadOnlyIconProps) => {
    const { dataRowOwnerId } = props;
    const pdlContext = usePDL();
    const id = useId();
    const contributingPosition = pdlContext.positions.find(x => x.id === dataRowOwnerId);

    if (!contributingPosition) {
        return (
            <div className="text-center">
                <FontAwesomeIcon icon={faLock} fixedWidth={true} title="Denna registrering är gjord av en annan klinik och är därför skrivskyddad." style={helpStyle} />
            </div>
        );
    }

    const hasContactInfo = !!(contributingPosition.data.POS_CONTACT_NAME
        || contributingPosition.data.POS_CONTACT_EMAIL
        || contributingPosition.data.POS_CONTACT_PHONE);

    const tooltip = (
        <Popover id={id}>
            <p>
                Denna registrering är gjord av av <strong>{contributingPosition.data.PosNameWithCode}</strong> och är därför skrivskyddad.
            </p>

            {!hasContactInfo && <em>Kontaktuppgifter till kliniken saknas.</em>}

            {hasContactInfo && (
                <div>
                    <div>Kontaktuppgifter:</div>
                    {contributingPosition.data.POS_CONTACT_NAME && <div>{contributingPosition.data.POS_CONTACT_NAME}</div>}
                    {contributingPosition.data.POS_CONTACT_EMAIL && <div>{contributingPosition.data.POS_CONTACT_EMAIL}</div>}
                    {contributingPosition.data.POS_CONTACT_PHONE && <div>{contributingPosition.data.POS_CONTACT_PHONE}</div>}
                </div>
            )}
        </Popover>
    );

    return (
        <OverlayTrigger overlay={tooltip}>
            <FontAwesomeIcon className="py-0" icon={faLock} fixedWidth={true} />
        </OverlayTrigger>
    );
};

export default ReadOnlyIconButton;
